import {useSelector} from "react-redux";

import {type AppreciationKey, selectAppreciationValueOrDefaultCurried} from "../../redux/appreciationsUtil";
import {selectReadOnly} from "../../redux/persistenceSlice";
import AppreciationInputText from "./AppreciationInputText";
import {resolveAppreciationId, useAppreciationVisibilityFromContext, useAppreciationVisible} from "./appreciationHooks";

interface AppreciationTabInputTextProps {
    /** option1: provide appreciation key */
    appreciationKey?: AppreciationKey;
    /** option2: provide appreciation page and tab, to calculate key */
    page?: string;
    tab?: string;
}

/**
 * Wrapper for AppreciationInputText, styled for use as tab-level, full-width input box.
 */
export default function AppreciationTabInputText({appreciationKey, page, tab}: AppreciationTabInputTextProps) {
    const effectiveAppreciationKey = resolveAppreciationId(appreciationKey, page, tab);
    const effectiveVisible = useAppreciationVisibilityFromContext(effectiveAppreciationKey);
    const readOnly = useSelector(selectReadOnly);
    const storedValue = useSelector(selectAppreciationValueOrDefaultCurried(effectiveAppreciationKey));
    const appreciationVisible = useAppreciationVisible(effectiveAppreciationKey);

    // Appreciation UI requires permission, except for the always-visible exception fields (#18607)
    if (!appreciationVisible || (!effectiveVisible && !readOnly) || (readOnly && !storedValue)) return null;

    return (
        <div className="p-inputtext-sm text-sm mt-0 mb-4">
            <AppreciationInputText appreciationKey={appreciationKey} page={page} tab={tab} autoFocus={true} />
        </div>
    );
}
